const mutation = {
  setTravelAuth(state, { data }) {
    state.hasTravelAuth = data && ( data.hotel > 0 || data.flight > 0 || data.train > 0)
  },
}

export default mutation